import { client } from "@/api/client";
import interceptors from "@/api/interceptor";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);


function getSaldoSummaryDepositReseller(params) {
	return client.get("seller/store-balance/summary-deposit-reseller", {
		params: params,
	});
}

function getDepositResellerMutasi(params) {
	return client.get("seller/store-balance/list_deposit_reseller_history", {
		params: params,
	});
}

function getSaldoSummary(params) {
	return client.get("seller/store-balance/summary", {
		params: params,
	});
}
function getSaldoMutasi(params) {
	return client.get("seller/store-balance/data", {
		params: params,
	});
}

function getSaldoWithdraw(params) {
	return client.get("seller/store-withdrawal/data", {
		params: params,
	});
}

function getWithdrawDepositReseller(params) {
	return client.get("seller/store-withdrawal/data-deposit-reseller", {
		params: params,
	});
}

function requestWithdraw(params) {
	return client.post("seller/store-withdrawal/request", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function requestWithdrawDepositReseller(params) {
	return client.post("seller/store-withdrawal/request-deposit-reseller", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function previewWithdrawDepositReseller(params) {
	return client.post("seller/store-withdrawal/preview-deposit-reseller", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

export default {
	getSaldoSummary,
	getSaldoMutasi,
	getSaldoWithdraw,
	requestWithdraw,
	getSaldoSummaryDepositReseller,
	getDepositResellerMutasi,
	requestWithdrawDepositReseller,
	previewWithdrawDepositReseller,
	getWithdrawDepositReseller
};